<template>

  <v-dialog
      v-model="dialog"
      persistent
      width="unset"
  >
    <template v-slot:activator="{ on, attrs }">
      <div  v-if="desconectado==true">
      <v-btn
          rounded
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
      >
        Iniciar Sesión
      </v-btn></div>
      <div v-else-if="desconectado==false">
        <v-menu  offset-y min-width="200px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                v-bind="attrs"
                v-on="on"
                color="primary"
                dark
                elevation="5"
                fab
            >
              {{ abreviado }}
            </v-btn>
          </template>
          <v-list color="#393E46" subheader>
            <v-subheader>Fiestas y Eventos</v-subheader>
            <v-list-item>
              <v-list-item-action>
                <router-link color="white" style="text-decoration: none;"  :to="{ name: 'misqr'}">
                  <v-avatar><img src="@/assets/icons/codigo-qr.png"></v-avatar>
                </router-link>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title><router-link color="white" style="text-decoration: none; color: white;"  :to="{ name: 'misqr'}">QRs</router-link></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-action>
                <router-link color="white" style="text-decoration: none;"  :to="{ name: 'tickets'}">
                  <v-avatar><img src="@/assets/icons/tickets.png"></v-avatar>
                </router-link>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title><router-link color="white" style="text-decoration: none; color: white;"  :to="{ name: 'tickets'}">Entradas</router-link></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item> <v-list-item-action>
              <router-link color="white" style="text-decoration: none;"  :to="{ name: 'suscripciones'}">
                <v-avatar><img src="@/assets/icons/carnet.png"></v-avatar>
              </router-link>
            </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title><router-link color="white" style="text-decoration: none; color: white;"  :to="{ name: 'suscripciones'}">Membresias</router-link></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-subheader>Mis Datos</v-subheader>
            <v-list-item> <v-list-item-action>
              <router-link color="white" style="text-decoration: none;"  :to="{ name: 'perfil'}">
                <v-avatar><img src="@/assets/icons/profile.png"></v-avatar>
              </router-link>
            </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title><router-link color="white" style="text-decoration: none; color: white;"  :to="{ name: 'perfil'}">Perfil</router-link></v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item> <v-list-item-action>
              <v-avatar><img src="@/assets/icons/logout.png"></v-avatar>
            </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title @click="desconectar" style="cursor:grab;">Desconectar</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>

        </v-menu>
        <v-menu offset-y min-width="200px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                v-bind="attrs"
                v-on="on"
                :ripple="false"
                text
                style="font-size: 10pt;"
            >
              Acciones
            </v-btn>
          </template>
          <v-list color="#393E46">
            <v-list-item v-if="ttnegocios" >
              <v-list-item-action>
                <router-link color="white" style="text-decoration: none;"  :to="{ name: 'Dashboard'}"><v-avatar

                    elevation="5"
                >
                  <img src="@/assets/icons/my-business.png">
                </v-avatar></router-link>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title><router-link color="white" style="text-decoration: none; color: white;"  :to="{ name: 'Dashboard'}">Negocios</router-link></v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item v-if="ttnegocios" >
              <v-list-item-action>
                <router-link color="white" style="text-decoration: none;"  :to="{ name: 'negociossorteo'}"><v-avatar
                    elevation="5"
                >
                  <img src="@/assets/icons/sorteo.png">
                </v-avatar></router-link>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title><router-link color="white" style="text-decoration: none; color: white;"  :to="{ name: 'negociossorteo'}">Sorteos</router-link></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="tsuperadmin" >
              <v-list-item-action>
                <router-link color="white" style="text-decoration: none;"  :to="{ name: 'DashSuperAdmin'}"><v-avatar
                    elevation="5"
                >
                  <img src="@/assets/icons/administrator.png" >

                </v-avatar></router-link>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title><router-link color="white" style="text-decoration: none; color: white;"  :to="{ name: 'DashSuperAdmin'}">Super Admin</router-link></v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item v-if="tpromotor" >
              <v-list-item-action>
                <router-link color="white" style="text-decoration: none;"  :to="{ name: 'mislinks'}"><v-avatar

                    elevation="5"
                >
                  <img src="@/assets/icons/comercializador.png">
                </v-avatar></router-link>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title><router-link color="white" style="text-decoration: none; color: white;"  :to="{ name: 'mislinks'}">Promotor</router-link></v-list-item-title>
              </v-list-item-content>
            </v-list-item>


            <v-list-item >
              <v-list-item-action>
                <router-link color="white" style="text-decoration: none;"  :to="{ name: 'Eventos'}"><v-avatar
                    elevation="5"
                    @click="$router.push({name:'Eventos'})"
                >
                  <img src="@/assets/icons/events.png">
                </v-avatar></router-link>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title><router-link color="white" style="text-decoration: none; color: white;"  :to="{ name: 'Eventos'}">Eventos</router-link></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item >
              <v-list-item-action>
                <router-link color="white" style="text-decoration: none;"  :to="{ name: 'Juegos'}"><v-avatar
                    elevation="5"
                    class="  hidden-sm-only hidden-xs-only"
                >
                  <img src="@/assets/icons/gamepad.png" />
                </v-avatar></router-link>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title><router-link color="white" style="text-decoration: none; color: white;"  :to="{ name: 'Juegos'}">Juegos</router-link></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>


      </div>
    </template>
    <v-card  color="#393E46">
      <v-card-title class="text-h5">
        <v-img
            alt="Tunay Logo"
            class="shrink mt-1 "
            contain
            min-width="100"
            src="@/assets/tunaywhitelogo.png"
            width="100"
        />
      </v-card-title>


        <v-tabs
            v-model="tab"
            background-color="transparent"
            grow
        >
          <v-tab
              key="Conectarse"
          >
            Iniciar Sesión
          </v-tab>
          <v-tab
              key="Registrarse"
          >
           Registrarse
          </v-tab>

        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item
              key="Conectarse"
          >
            <v-card
                color="#393E46"
                flat
            >
              <v-card-text>
              <v-form>
                <v-alert
                    :value="alertloginerror"
                    color="error"
                    dark
                    dismissible
                    border="top"
                    transition="scale-transition"
                >
                {{error}}
                </v-alert>
                <v-row align="center" justify="center">
                  <v-col lg="6" md="6" cols="12">
                <v-text-field
                    v-model="form.email"
                    :rules="emailRules"
                    type="email"
                    name="email"
                    label="E-mail"
                    value
                    required
                    autofocus
                ></v-text-field>
                  </v-col>
                </v-row>
                <v-row align="center" justify="center">

                  <v-col lg="6" md="6" cols="12">
                    <v-text-field
                        id="password"
                        type="password"
                        class="form-control"
                        name="password"
                        label="Password"
                        required
                        v-model="password"
                    />
                  </v-col>
                </v-row>
                <v-row  class="mb-0">
                  <v-col md="6" style="text-align: right;" lg="6" cols="6" sm="6">
                    <v-btn @click="submit" rounded class="primary">Ingresar</v-btn>
                  </v-col>
                  <v-col md="6" lg="6" cols="6" sm="6" style="text-align: left">
                    <v-btn class="error" rounded @click="closs">Cerrar</v-btn>
                  </v-col>
                </v-row>
              </v-form>
<v-row v-if="browser">
  <v-col>
    <v-btn rounded style="background: #4F86EC;" @click="signingoogle">
      <v-icon>fab fa-google</v-icon> Ingresar con Google
    </v-btn>
  </v-col>
  <v-col>
    <v-btn rounded style="background: #E0E5FA; color: black;" @click="signinapple">
      <v-icon>fab fa-apple</v-icon> Ingresar con Apple
    </v-btn>
  </v-col>
</v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item
              key="Registrase"
          >
            <v-card
                color="#393E46"
                flat
            >
              <v-card-text>
                <v-alert
                    :value="alerterror"
                    color="error"
                    dark
                    dismissible
                    border="top"
                    transition="scale-transition"
                >
                  {{error}}
                </v-alert>
                <v-form>
                  <v-row align="center" justify="center">
                    <v-col lg="12" md="12" cols="12">Al registrarse está aceptando nuestros <a href="https://tunay.app/terminos" target="_blank">Terminos y Condiciones</a> y <a href="https://tunay.app/politicas" target="_blank">Políticas de Privacidad</a></v-col>
                    <v-col lg="6" md="6" cols="12">
                      <v-text-field
                          v-model="form.nombre"
                          type="text"
                          name="nombre"
                          label="Nombre"
                          value
                          required
                          autofocus
                      ></v-text-field>
                    </v-col>
                    <v-col lg="6" md="6" cols="12">
                      <v-text-field
                          v-model="form.apellidoPaterno"
                          type="text"
                          name="appaterno"
                          label="Apellido Paterno"
                          value
                          required
                          autofocus
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row align="center" justify="center">
                    <v-col lg="6" md="6" cols="12">
                      <v-autocomplete
                      v-model="form.paisNac"
                      :items="paises"
                      return-object
                      label="Pais Nacimiento"
                      item-text="pais"
                      >
                        <template v-slot:selection="data">
                          <v-chip
                              v-bind="data.attrs"
                              :input-value="data.selected"

                          >
                            <v-avatar left>
                              <v-img :src="require(`@/assets/flags/gc_country_flag_${data.item.codigo}.svg`)"></v-img>
                            </v-avatar>
                            {{ data.item.pais }}
                          </v-chip>
                        </template>
                        <template v-slot:item="data">
                          <template v-if="typeof data.item !== 'object'">
                            <v-list-item-content v-text="data.item"></v-list-item-content>
                          </template>
                          <template v-else>
                            <v-list-item-avatar>
                              <img :src="require(`@/assets/flags/gc_country_flag_${data.item.codigo}.svg`)">
                            </v-list-item-avatar>
                            <v-list-item-content>
                              <v-list-item-title v-html="data.item.pais"></v-list-item-title>
                            </v-list-item-content>
                          </template>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col lg="6" md="6" cols="12">
                      <v-text-field
                          v-model="form.email"
                          :rules="emailRules"
                          type="email"
                          name="email"
                          label="E-mail"
                          value
                          required
                          autofocus
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row align="center" justify="center">
                <v-col lg="6" md="6" cols="12">
                      <v-text-field
                          id="password"
                          type="password"
                          class="form-control"
                          name="password"
                          label="Password"
                          required
                          v-model="password"
                      />
                    </v-col>

                    <v-col lg="6" md="6" cols="12">
                      <v-text-field
                          id="password"
                          type="password"
                          class="form-control"
                          label="Confirmar Password"
                          required
                          v-model="confirmpass"
                      />
                    </v-col>
                  </v-row>
                  <v-row class="mb-0">
                    <v-col md="6" lg="6" cols="6" sm="6" style="text-align: right">
                      <v-btn rounded @click="register" class="primary">Registrarse</v-btn>
                    </v-col>
                    <v-col md="6" lg="6" cols="6" sm="6" style="text-align: left">
                      <v-btn rounded class="error" @click="closs">Cerrar</v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-btn v-if="browser" rounded style="background: #4F86EC;" @click="creategoogle">
                        <v-icon>fab fa-google</v-icon> &nbsp;Registrar con Google
                      </v-btn>
                    </v-col>
                    <v-col>
                      <v-btn v-if="browser" rounded style="background: #E0E5FA; color: black;" @click="createapple">
                        <v-icon>fab fa-apple</v-icon> &nbsp;Registrar con Apple
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>


    </v-card>
    <v-overlay :value="overlay">
      <v-img
          src="@/assets/loadtunay.gif"

      />
    </v-overlay>
  </v-dialog>

</template>

<script>
import firebase from 'firebase/compat/app';
import axios from 'axios';
import store from "@/store";
import tipoentrjson from "@/assets/json/tipoentradas.json";
import tipopagjson from "@/assets/json/tipopagos.json";
import tipoevenjson from "@/assets/json/tipoeventos.json";
import tipomembrjson from "@/assets/json/tipomembresias.json";
import sexosjson from "@/assets/json/sexos.json";
import estadocarjson from "@/assets/json/estadocarnet.json";
import diasjson from "@/assets/json/dias.json";
import moment from "moment";
import {mapGetters} from "vuex";


export default {
  name: 'loginboxmobile',
  components: {},
  props:{
    paises: {
      type: Array
    },
    ttnegocios:{
      type: Boolean
    },
    tpromotor:{
      type: Boolean
    },
    desconectado:{
      type: Boolean
    },
    tsocio:{
      type: Boolean
    },
    tsuperadmin:{
      type: Boolean
    },
    browser:{
      type: Boolean
    },
    abreviado:{
      type: String
    }
  },
  data: () => ({
    tab: null,
    dialog:false,
    alertloginerror:false,
    alerterror:false,

    ttnegocios:false,
    form: {
      nombre: "",
      apellidoPaterno: "",
      apellidoMaterno: "",
      dni : "",
      foto: "",
      email: "",
      paisNac:null,
      tipoDocumento: null,
      telefono:"",
      direccion:"",
      fechaNacimiento:null,
      sexo:null,
      fotoDni:"",
      postalCode:"",
      distrito:null,
      createdAt:"",
      uidFirebase: "",
      isprofile: true,
      isfoto : false,
      isverified: false
    },
    rese:'',
    mnegocios : null,

    negociospromotor:[],

    password: "",
    token:'',
    confirmpass: "",
    getips:'',
    error:'',
    overlay:false,
    emailRules: [
      v => !!v || 'E-mail es obligatorio',
      v => /.+@.+\..+/.test(v) || 'E-mail debe ser válido',
    ],
  }),
  watch: {
    '$store.state.usuario': function() {

      this.negociospromotor = this.pnegocios
      this.tpromotor = this.usuario.promotor
      this.tsuperadmin = this.usuario.superAdmin
      this.token  = firebase.auth().currentUser.auth.currentUser.accessToken;

      store.dispatch("fetchUsuario",store.state.usuario)
      store.dispatch("conectarse")
    },
    '$store.state.negocios': function() {
      if(store.state.negocios !== null){
        store.dispatch("connegocios")
      }
    }
  },


  methods: {
    formatDateee(value) {
      return moment(value).locale('es-pe').format("YYYY-MM-DD hh:mm:ss")
    },
    fnBrowserDetect(){

      let userAgent = navigator.userAgent;

      if(userAgent.match(/chrome|chromium|crios/i)){
        this.rese = "chrome";
        this.browser = true;
      }else if(userAgent.match(/firefox|fxios/i)){
        this.rese = "firefox";
        this.browser = true;
      }  else if(userAgent.match(/safari/i)){
        this.rese = "safari";
        this.browser = true;
      }else if(userAgent.match(/opr\//i)){
        this.rese = "opera";
        this.browser = true;
      } else if(userAgent.match(/edg/i)){
        this.rese = "edge";
        this.browser = true;
      }else{
        this.rese="No browser detection";
        this.browser = false;
      }

    },
    getPaises(){
      axios.get("paises/activos",{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      })
      .then(response=>{
        this.paises = response.data
      })
    },
    desconectar(){
      this.desconectado = true;
      store.dispatch("desconectarse")
      firebase
      .auth()
      .signOut();

      this.$router.push({path: "/"})
    },
    registrar(user){
      this.form.uidFirebase = user.uid
      var bodyFormData = new FormData();
      this.form.createdAt = this.formatDateee(new Date())

      bodyFormData.append('data',JSON.stringify(this.form));
      axios.post("personas/registrar",bodyFormData,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      })
          .then(response => {
            store.dispatch("fetchUsuario", response.data.persona);
            store.dispatch("fetchTipoEntradas", tipoentrjson);
            store.dispatch("fetchTipoPagos", tipopagjson);
            store.dispatch("fetchTipoEventos", tipoevenjson);
            store.dispatch("fetchTipoMembresias", tipomembrjson);
            store.dispatch("fetchSexos", sexosjson);
            store.dispatch("fetchEstadoCarnets", estadocarjson);
            store.dispatch("fetchDias", diasjson);
            store.dispatch("conectarse")
            this.overlay = false;
            this.dialog=false;
            this.tpromotor = response.data.persona.promotor
            this.tsuperadmin = response.data.persona.superAdmin
            this.desconectado = false;
          })
          .catch(error => {
            this.error = "Hubo un error con su Conexion";
            this.overlay = false;
            this.alertloginerror = true;
            console.log(error);
          });
    },

    register(){
      if(this.password === this.confirmpass) {
        this.overlay = true;
        firebase
            .auth()
        .createUserWithEmailAndPassword(this.form.email,this.password)
        .then((userCredential) =>{
            const user = userCredential.user
            this.registrar(user)
        })
            .catch(error => {
              if(error.code ==="auth/email-already-exists"){
                this.error = "Este email existe en Tunay, se le esta enviando un mail automático para cambiar de contraseña, luego de cambiarla pruebe con el LOGIN no trate de REGISTRARSE de nuevo";
                firebase
                    .auth()
                    .sendPasswordResetEmail(this.form.email);
              }else{
                if(error.code === "auth/email-already-in-use"){
                  this.error = "Su Correo existe en nuestra base de datos con Google Mail o Apple Login por favor intente con Registrarse con Google o Registrarse con Apple, tambien puede intentarlo con Login con Google o Login con Apple";
                  this.alerterror = true;
                }else{
                  this.error = "Hubo un error con su Conexion";

                }
              }
              this.overlay = false;
              this.alerterror = true;

              console.error(error);
            });
      }
    },
    compruebaemail(user){
      var bodyFormData2 = new FormData();
      bodyFormData2.append("email",this.form.email)
      axios
          .post('personas/email',bodyFormData2,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            var person = response.data
            if (person.id == null){
              this.registrar(user)
            }else{
              if(person.uidFirebase == null) {
                this.editar(user,person.id)
              }else{
                if(person.uidFirebase !== user.uid ){
                  this.editar(user,person.id)
                }else{
                  this.recaptcha(user)
                }
              }
            }
          })
          .catch((error)  => {
            console.log(error);
          });
    },
    editar(user,id){
      this.form.uidFirebase = user.uid
      var bodyFormData = new FormData();
      this.form.createdAt = this.formatDateee(new Date())
      this.form.fechaNacimiento = null
      bodyFormData.append('uidfirebase',this.form.uidFirebase);
      bodyFormData.append("personaId",id)
      this.overlay = true
      axios.post("personas/editafb",bodyFormData,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      })
          .then(response => {
            console.log(response.data);
            this.overlay = false
            this.recaptcha(user)
          })
          .catch(error => {
            console.log(error)
            this.overlay = false
          });
    },
    createapple(){
      var provider = new firebase.auth.OAuthProvider('apple.com')
      firebase.auth().languageCode = 'es'
      provider.setCustomParameters({
        'display': 'popup'
      });
      firebase
          .auth()
          .signInWithPopup(provider)
          .then((result) =>{
            // var credential = result.credential;

            // The signed-in user info.
            var user = result.user;
            this.form.nombre = user.displayName
            this.form.email =  user.email
            this.form.foto =  user.photoURL
            // This gives you a Facebook Access Token. You can use it to access the Facebook API.
            // var accessToken = credential.accessToken;
            this.token  = firebase.auth().currentUser.auth.currentUser.accessToken;

            this.compruebaemail(user)
            // ...
          })
          .catch((error) => {
            // Handle Errors here.
            var errorCode = error.code;
            // var errorMessage = error.message;
            // The email of the user's account used.
            // var email = error.email;
            // The firebase.auth.AuthCredential type that was used.
            // var credential = error.credential;
            console.log(errorCode)
            this.error = "Hubo un error con su Conexion";
            this.overlay = false;
            this.alertloginerror = true;
            // ...
          });
    },
    signinapple(){
      var provider = new firebase.auth.OAuthProvider('apple.com')
      firebase.auth().languageCode = 'es'
      provider.setCustomParameters({
        'display': 'popup'
      });
      firebase
          .auth()
          .signInWithPopup(provider)
          .then((result) =>{
            // var credential = result.credential;

            // The signed-in user info.
            var user = result.user;

            // This gives you a Facebook Access Token. You can use it to access the Facebook API.
            // var accessToken = credential.accessToken;
            this.token  = firebase.auth().currentUser.auth.currentUser.accessToken;

            this.recaptcha(user)
            // ...
          })
          .catch((error) => {
            // Handle Errors here.
            var errorCode = error.code;
            // var errorMessage = error.message;
            // The email of the user's account used.
            // var email = error.email;
            // The firebase.auth.AuthCredential type that was used.
            // var credential = error.credential;
            console.log(errorCode)
            this.error = "Hubo un error con su Conexion";
            this.overlay = false;
            this.alertloginerror = true;
            // ...
          });
    },

    creategoogle(){
      var provider = new firebase.auth.GoogleAuthProvider()
      firebase.auth().languageCode = 'es'
      provider.setCustomParameters({
        'display': 'popup'
      });
      firebase
          .auth()
          .signInWithPopup(provider)
          .then((result) =>{
            // var credential = result.credential;

            // The signed-in user info.
            var user = result.user;
            this.form.nombre = user.displayName
            this.form.email =  user.email
            this.form.foto =  user.photoURL
            this.token  = firebase.auth().currentUser.auth.currentUser.accessToken;

            // This gives you a Facebook Access Token. You can use it to access the Facebook API.
            // var accessToken = credential.accessToken;
            this.compruebaemail(user)
            // ...
          })
          .catch((error) => {
            // Handle Errors here.
            var errorCode = error.code;
            this.error = "Hubo un error con su Conexion";
            this.overlay = false;
            this.alertloginerror = true;
            // var errorMessage = error.message;
            // The email of the user's account used.
            // var email = error.email;
            // The firebase.auth.AuthCredential type that was used.
            // var credential = error.credential;
            console.log(errorCode)
            // ...
          });
    },
    signingoogle(){
      var provider = new firebase.auth.GoogleAuthProvider()
      firebase.auth().languageCode = 'es'
      provider.setCustomParameters({
        'display': 'popup'
      });
      firebase
          .auth()
          .signInWithPopup(provider)
          .then((result) =>{
            // var credential = result.credential;

            // The signed-in user info.
            var user = result.user;
            console.log(user)

              this.form.nombre = user.displayName
              this.form.email =  user.email
              this.form.foto =  user.photoURL
            // This gives you a Facebook Access Token. You can use it to access the Facebook API.
            // var accessToken = credential.accessToken;
            this.token  = firebase.auth().currentUser.auth.currentUser.accessToken;

            this.compruebaemail(user)

          })
          .catch((error) => {
            // Handle Errors here.
            var errorCode = error.code;
            this.error = "Hubo un error con su Conexion";
            this.overlay = false;
            this.alertloginerror = true;
            // var errorMessage = error.message;
            // The email of the user's account used.
            // var email = error.email;
            // The firebase.auth.AuthCredential type that was used.
            // var credential = error.credential;
            console.log(errorCode)
            // ...
          });
    },
    closs() {
      this.dialog = false
    },
    submit() {
      this.overlay = true;
      firebase
          .auth()
          .signInWithEmailAndPassword(this.form.email, this.password)
          .then(data => {
            this.token  = firebase.auth().currentUser.auth.currentUser.accessToken;

           this.recaptcha(data.user)
          })
          .catch(err => {
            if(err.code === "auth/user-not-found"){
              this.error = "No Existe este Email en nuestra base de datos";
              this.overlay = false;
              this.alertloginerror = true;
            }else{
              this.error = "Puede haber un error con el email y/o password";
              this.overlay = false;
              this.alertloginerror = true;

            }
          });
    },
    async recaptcha(user) {
      // (optional) Wait until recaptcha has been loaded.
      await this.$recaptchaLoaded()

      // Execute reCAPTCHA with action "login".
      this.tokencaptcha = await this.$recaptcha('login')
      // Do stuff with the received token.
      if(this.tokencaptcha !=='' ){
        this.logeo(user)
      }

    },
    logeo(user){
      var bodyFormData = new FormData();

      bodyFormData.append('uuid', user.uid);
      bodyFormData.append('token', this.tokencaptcha);

      this.overlay = true
      axios.post("personas/loginbyuid",bodyFormData,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      })
          .then(response => {
            store.dispatch("fetchUsuario", response.data.persona);

            if(response.data.usuarionegocio!==null){
              store.dispatch("fetchNegocios", response.data.usuarionegocio);
              store.dispatch("connegocios")
              localStorage.negocios = true
              this.ttnegocios = true
            }else{
              store.dispatch("sinnegocios")
              this.ttnegocios = false
              localStorage.negocios = false
            }
            if(response.data.clientes!==null){
              store.dispatch("fetchClientes", response.data.clientes);
              store.dispatch("fetchCliente", response.data.clientes[0]);
            this.teventos = true
              localStorage.eventos = true

            }else{
              store.dispatch("fetchCliente", response.data.usuarionegocio.negocio[0].cliente);
              this.teventos = false
              localStorage.eventos = false
            }
            this.tsuperadmin = response.data.persona.superAdmin

            store.dispatch("fetchTipoEntradas", tipoentrjson);
            store.dispatch("fetchTipoPagos", tipopagjson);
            store.dispatch("fetchTipoEventos", tipoevenjson);
            store.dispatch("fetchTipoMembresias", tipomembrjson);
            store.dispatch("fetchSexos", sexosjson);
            store.dispatch("fetchEstadoCarnets", estadocarjson);
            store.dispatch("fetchDias", diasjson);
            store.dispatch("conectarse");
            this.desconectado = false;
            this.overlay = false;
            this.dialog=false;
            this.tpromotor = response.data.persona.promotor
          })
          .catch(error => {
            this.overlay = false;
            console.log(error);
          });
    }
  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    ...mapGetters({
      usuario: "usuario",
      cliente: "cliente",
      clientes:"clientes",
      pnegocios: "pnegocios",
      conectado: "conectado",
      negocios: "negocios",
      tnegocios: "tnegocios"
    })
  }
}
</script>
